
export const AddressTypeConsultantToDeliver = 'consultant_to_deliver';
export const AddressTypePickup = 'pickup';
export const AddressTypeStreet = 'street';
export const AddressTypeLast = 'last';

export interface Address {
  type?: string;
  pickup?: boolean;
  line1?: string;
  line2?: string;
  line3?: string;
  line4?: string;
  city?: string;
  region?: string;
  suburb?: string;
  postal_code?: string;
  country?: string;
  complex?: string;
  validated?: boolean;

  contact_person?: string;
  contact_number?: string;

  lat?: number;
  long?: number;
}

function New(): Address {
  return {
    type: 'last',
    pickup: false,
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    city: '',
    region: '',
    suburb: '',
    postal_code: '',
    country: '',
    complex: '',
    validated: false,

    contact_person: '',
    contact_number: '',

    lat: 0,
    long: 0
  };
}

function Copy(add: Address): Address {
  return {
    type: add.type,
    pickup: add.pickup,
    line1: add.line1,
    line2: add.line2,
    line3: add.line3,
    line4: add.line4,
    city: add.city,
    region: add.region,
    suburb: add.suburb,
    postal_code: add.postal_code,
    country: add.country,
    complex: add.complex,
    validated: add.validated,

    contact_person: add.contact_person,
    contact_number: add.contact_number,

    lat: add.lat,
    long: add.long
  };
}

// Clone alias
function Clone(add: Address): Address {
  return Copy(add);
}

function Valid(a: Address): boolean {
  if (!a.type) { a.type = AddressTypeStreet; }

  if (a.type === AddressTypeStreet || a.type === AddressTypeLast) {
    if (!a.line1) { return false; }
    if (!a.country) { return false; }
    if (!a.city) { return false; }
    if (!a.region) { return false; }
  }

  return true;
}

export default {
  New,
  Copy,
  Clone,
  Valid
};
